import type { AppFlagKey } from 'environment';
import { User } from 'prismas';
import { type ZInfer, type authSchemas } from 'types';
import { Api } from '..';

// async function adminGetMonetaryDonations(reason?: MonetaryDonationReason, lastDate?: number) {
//   const [data] = await OldApi.get<DonateControllerRouteReturns['adminGet']>(`/donate/admin`, {
//     params: { reason, lastDate },
//   });
//   return data;
// }

// async function getUsers(skip?: number, count?: number) {
//   const currentSkip = skip || 0;
//   const currentCount = count || 50;

//   const [data] = await OldApi.get<AuthControllerRouteReturns['adminGetUsers']>(
//     `/auth/admin?count=${currentCount}&skip=${currentSkip}`,
//   );

//   return data;
// }

// async function getContactUs(skip: number = 0, count: number = 50) {
//   return await Api.get<'contact', 'adminGet'>(`/contact/admin`, { query: { skip, count } });
// }

// async function getUserDonations(id: string) {
//   return await Api.get<'donate', 'adminGetByUser'>(`/donate/admin/user/:id`, { params: { id } });
// }

// async function getUserAddresses(id: string) {
//   const [data] = await OldApi.get(`/admin/user/${id}/address`);
//   return data;
// }

/** This is obv web-only :) */
const getDeliveryFeeCsv = async () => {
  const res = await Api.get<'adminDonation', 'adminGetDeliveryFeeCsv'>('/admin/donations/csv/delivery-fees');
  if (res.success === false) return;

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `donations-${Math.floor(new Date().getTime() / 1000)}.csv`);
  document.body.appendChild(link);
  link.click();
};

export class AdminNet {
  static admin = {
    getUser: (id: string) => Api.get<'admin', 'getUser'>('/admin/user/:id', { params: { id } }),
    updateUser: (id: string, user: Partial<User>) =>
      Api.patch<'admin', 'updateUser'>('/admin/user/:id', { params: { id }, body: user }),
    inviteAdmin: (body: ZInfer<typeof authSchemas.admin.invite>) =>
      Api.post<'admin', 'inviteAdmin'>('/admin/invite', { body }),
    inviteReferralPartner: (body: ZInfer<typeof authSchemas.admin.inviteReferral>) =>
      Api.post<'admin', 'inviteReferralPartner'>('/admin/invite/referral', { body }),
    inviteStaff: (body: ZInfer<typeof authSchemas.admin.invite>) =>
      Api.post<'admin', 'inviteStaff'>('/admin/invite/staff', { body }),
    getUmamiCredentials: () => Api.get<'admin', 'getUmamiCredentials'>('/admin/credentials/umami'),
    setFlag: (key: AppFlagKey, enabled: boolean) =>
      Api.post<'flag', 'set'>('/flag/:key', { params: { key }, body: { enabled } }),
  };
  static donation = {
    getDeliveryFeeCsv,
    get: (lastDate: number = 0, campaign?: string) =>
      Api.get<'adminDonation', 'get'>('/admin/donations', { query: { lastDate, campaign } }),
    getByUser: (userId: string) =>
      Api.get<'adminDonation', 'getByUser'>('/admin/donations/user', { query: { userId } }),
  };
}
